// TODO: @danealton Если решим доработать для кросплатформенной поддержки, то вот неплохой материал
// https://spemer.com/articles/set-favicon-with-javascript.html

export default (source) => {
  const headTitle = document.querySelector('head');

  const faviconIcons = [
    { rel: 'apple-touch-icon' },
    { rel: 'apple-touch-startup-image' },
    { rel: 'shortcut icon' },
  ];

  faviconIcons.forEach(favIcon => {
    const faviconLink = document.createElement('link');
    faviconLink.setAttribute('rel', favIcon.rel);
    faviconLink.setAttribute('href', source);
    headTitle.appendChild(faviconLink);
  });
};
